import { render, staticRenderFns } from "./OrderStoreAttentionDetail.vue?vue&type=template&id=35c46669"
import script from "./OrderStoreAttentionDetail.vue?vue&type=script&lang=js"
export * from "./OrderStoreAttentionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports